import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../componentes/alerts/sweetAlert";
import { useEffect, useState } from "react"
import { CargosEliminar, CargosListar } from "../../../configuracion/apiUrls";
import { AxiosPrivado } from "../../../componentes/axios/Axios";

const EliminarCargo = ({ datos, token, setListaCargos, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(()=>{
        if(eliminar)
            eliminarCargo();
    },[eliminar])
    const eliminarCargoPregunta = async (f) =>{
        mostraAlertaPregunta(setEliminar, "¿Deseas eliminar el cargo "+ datos.nombre_cargo +" de forma permanente?", "warning");
    }
  
    const eliminarCargo = async () =>{
        if (!datos.id)
            mostraAlertaError("Seleccione un cargo");
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(CargosEliminar + datos.id)
                    .then((respuesta) => {
                        ActualizarLista(CargosListar, setListaCargos);
                        mostraAlertaOk("Registro eliminado correctamente");
                    }).catch((er) => {
                        console.log(er);
                        var msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. '
                                    })
                                }
                                break;
                            case 400:
                                msjError = er.response.data.error;
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    })
            } catch (error) {
                mostraAlertaError("Error en la pedición")
            }
        }
      setEliminar(false);
    }
    
    return (
        <button type="button" className="btn btn-outline-danger" onClick={eliminarCargoPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
}
export default EliminarCargo;